export const Hotspot3DAttributeValues = {
    // Keyframe values for animating scale of border for default state.  Groups of 3, - x,y,z
    HOTSPOT_DEFAULT_BORDER_SCALE_ANIM_KEYFRAME_SEQUENCE: [
        1.2,
        1.2,
        1.2,
        0.95,
        0.95,
        0.95,
        0.95,
        0.95,
        0.95,
        2.5,
        2.5,
        2.5,
    ],
    // Keyframe values for animating opacity of border for default state.  0-1 scale
    HOTSPOT_DEFAULT_BORDER_OPACITY_ANIM_KEYFRAME_SEQUENCE: [0, 0, 1, 0, 1, 0],
    // Keyframe values for animating opacity of icon for default state.  0-1 scale
    HOTSPOT_DEFAULT_ICON_OPACITY_ANIM_KEYFRAME_SEQUENCE: [0, 0, 1, 1, 0],
    // Keyframe values for animating scale of icon for panning state.  Groups of 3, - x,y,z
    HOTSPOT_PANNING_ICON_SCALE_ANIM_KEYFRAME_SEQUENCE: [1.1, 1.1, 1.1, 1.4, 1.4, 1.4],
    // Keyframe values for animating opacity of icon for visited state.  0-1 scale
    HOTSPOT_VISITED_ICON_OPACITY_ANIM_KEYFRAME_SEQUENCE: [1, 0.25],

    // Offset for blur effect in physical space.  Needed to avoid z-fighting
    BLUR_OFFSET: {
        x: 0,
        y: 0.0075,
        z: 0,
    },

    // Offset and scale for visited checkmark
    VISITED_CHECK_OFFSET: {
        x: 0.4,
        y: 0.4,
        z: 0,
    },
    VISITED_CHECK_SCALE: {
        x: 0.4,
        y: 0.4,
        z: 0.4,
    },

    // Scale values for body and icon
    BODY_SCALE: {
        x: 0.95,
        y: 0.95,
        z: 0.95,
    },
    ICON_SCALE: {
        x: 1.1,
        y: 1.1,
        z: 1.1,
    },

    // Sizing and positioning values for root object
    HEIGHT: 0.5,
    MESH_POSITION: {
        x: 0,
        y: 0,
        z: 0,
    },
    ABSOLUTE_SCALE: 150,

    // Hit mesh customization
    HIT_RADIUS: 0.34,
    HIT_MESH_OFFSET: 0.2,
}

export const Hotspot3DSpeeds = {
    // Timing and duration for default border opacity
    HOTSPOT_DEFAULT_BORDER_OPACITY_ANIM_TIMING: [0, 0.25, 1, 1.5, 2, 2.25],
    HOTSPOT_DEFAULT_BORDER_OPACITY_ANIM_DURATION: 2.25,

    // Timing and duration for default border scale
    HOTSPOT_DEFAULT_BORDER_SCALE_ANIM_TIMING: [0, 0.5, 1.85, 2.25],
    HOTSPOT_DEFAULT_BORDER_SCALE_ANIM_DURATION: 2.25,

    // Timing and duration for default icon opacity
    HOTSPOT_DEFAULT_ICON_OPACITY_ANIM_TIMING: [0, 0.25, 1, 2, 2.25],
    HOTSPOT_DEFAULT_ICON_OPACITY_ANIM_DURATION: 2.25,

    // Timing and duration for panning icon scale
    HOTSPOT_PANNING_ICON_SCALE_ANIM_TIMING: [0, 0.5],
    HOTSPOT_PANNING_ICON_SCALE_ANIM_DURATION: 0.5,

    // Timing and duration for visited icon opacity
    HOTSPOT_VISITED_ICON_OPACITY_ANIM_TIMING: [0, 1],
    HOTSPOT_VISITED_ICON_OPACITY_ANIM_DURATION: 1,

    // Scale value for length of time over which hotspot animation initiation timing can be randomized
    HOTSPOT_TIMEOUT_RANDOMIZER_SCALE: 250,
}

export const Hotspot3DRotations = {}
